<template>
    <v-dialog
            v-model="showModal"
            max-width="700"
            persistent
    >
        <v-card class="text-center">
            <template v-if="errorMessage">
                <v-alert
                        type="error"
                >
                    {{ errorMessage }}
                </v-alert>
            </template>
            <validation-observer 
                    ref="validator"
                    v-slot="{ handleSubmit }"
            >
                <v-card-title class="text-sm-left font-weight-bold">
                    <template v-if="isCreate">
                        Thêm mới nhóm ngành
                    </template>
                    <template v-else>
                        Cập nhật thông tin nhóm ngành
                    </template>

                    <v-spacer />

                    <v-icon
                            aria-label="Close"
                            @click="hideModal"
                    >
                        mdi-close
                    </v-icon>
                </v-card-title>
                <v-card-text class="px-6">
                    <validation-provider
                            v-slot="{ errors }"
                            class="mb-2"
                            rules="required|max:255"
                            name="Tên nhóm ngành"
                    >
                        <v-text-field
                                v-model="schoolLevel.name"
                                label="Tên nhóm ngành *"
                                :error-messages="errors"
                                color="primary"
                        />
                    </validation-provider>

                    <validation-provider
                            v-slot="{ errors }"
                            class="mb-2"
                            rules="required|max:255"
                            name="Mã nhóm ngành"
                    >
                        <v-text-field
                                v-model="schoolLevel.code"
                                label="Mã nhóm ngành *"
                                :error-messages="errors"
                                color="primary"
                        />
                    </validation-provider>

                    <div class="group-input">
                        <ul>
                            <li class="title">
                                <h3 class="text-left">
                                    Link Url:
                                </h3>
                            </li>
                            <template v-for="(url, index) in schoolLevel.urls">
                                <li
                                        :key="url.id"
                                        class="list-input"
                                        name="Url"
                                >
                                    <validation-provider
                                            v-slot="{ errors }"
                                            class="mb-2"
                                            :rules="index == 0 ? {
                                                regex: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/,
                                                max: 255,
                                                required: true
                                            } : {
                                                regex: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/,
                                                max: 255,
                                            }"
                                            name="Url"
                                            vid="url"
                                    >
                                        <v-text-field
                                                v-model.trim="url.url"
                                                label="Url"
                                                color="primary"
                                                :error-messages="errors"
                                                clearable
                                        />
                                    </validation-provider>
                                    <v-icon
                                            v-if="index > 0"
                                            class="group-input-close"
                                            @click="deleteRow(url.id)"
                                    >
                                        mdi-delete
                                    </v-icon>
                                </li>
                            </template>
                        </ul>
                        <v-icon
                                class="group-input-add"
                                @click="addRow"
                        >
                            mdi-plus
                        </v-icon>
                    </div>

                    <validation-provider
                            v-slot="{ errors }"
                            class="mb-2"
                            name="Mô tả nhóm ngành"
                            rules="max: 255"
                    >
                        <v-textarea
                                v-model="schoolLevel.description"
                                label="Mô tả nhóm ngành"
                                :error-messages="errors"
                                color="primary"
                        />
                    </validation-provider>
                </v-card-text>

                <v-card-actions class="px-0 group-btn--form">
                    <v-btn
                            color="success"
                            @click.prevent="handleSubmit(saveSchoolLevel)"
                    >
                        Lưu lại
                    </v-btn>
                    <v-btn
                            class="ml-0"
                            color="primary"
                            @click="hideModal"
                    >
                        Hủy bỏ
                    </v-btn>
                </v-card-actions>
            </validation-observer>
        </v-card>
    </v-dialog>
</template>

<script>
import RepositoryFactory from "@/repositories/RepositoryFactory"
const SchoolLevelRepository = RepositoryFactory.get('school_level')

export default {
    data() {
        return {
            isCreate: true,
            schoolLevel: {},
            showModal: false,
            errorMessage: '',
            listURL: []
        }
    },
    created () {
        Bus.$on('school-level-show-form', async (schoolLevel) => {
            const loading = this.$loading.show()
            const { urls = [] } = schoolLevel
            if (urls.length === 0) {
                schoolLevel.urls = [{
                    id: (new Date()).getTime(),
                    url: '',
                }]
            }
            this.schoolLevel = _.cloneDeep(schoolLevel)
            if (schoolLevel.id) this.isCreate = false
            else this.isCreate = true
            this.getListURL()
            loading.hide()
            this.showModal = true
        })
    },
    methods: {
        hideModal() {
            this.showModal = false
            this.isCreate = true
            this.errorMessage = ''
            this.$refs.validator.reset()
        },

        addRow() {
            const schoolLevel = _.cloneDeep(this.schoolLevel)
            const { urls = [] } = schoolLevel
            urls.push({
                id: (new Date()).getTime(),
                inputUrl: '',
            })
            this.$set(this, 'schoolLevel', schoolLevel)
        },

        deleteRow(id) {
            const index = this.schoolLevel.urls.findIndex(u => u.id === id)
            if (index > -1) this.schoolLevel.urls.splice(index, 1)
        },

        async getListURL() {
            const listURL = []
            const responseURL = await SchoolLevelRepository.detail(this.schoolLevel.id)
            if (responseURL.success) {
                _.get(responseURL, 'data.urls', []).map(url => (
                    listURL.push(url.url)
                ))
            }
            this.listURL = listURL

            const urlsItem = this.schoolLevel.urls.map(e => e.inputUrl)
            this.urlsItem = urlsItem

            _.pull(this.listURL, ...urlsItem)
        },

        async saveSchoolLevel() {
            const body = {
                name: this.schoolLevel.name,
                code: this.schoolLevel.code,
                description: this.schoolLevel.description,
                urls: this.schoolLevel.urls.map(item => item.url)
            }

            if (this.isCreate) {
                const res = await SchoolLevelRepository.create(body)
                if (res.success) {
                    this.hideModal()
                    this.$swal({
                        title: 'Tạo mới nhóm ngành thành công!'
                    })
                    Bus.$emit('create-school-level')
                } else {
                    this.$swal({
                        title: 'Lỗi !',
                        text: _.get(res, 'message', '')
                    })
                }
            } else {
                const res = await SchoolLevelRepository.update(this.schoolLevel.id, body)
                if (res.success) {
                    this.hideModal()
                    this.$swal({
                        title: 'Cập nhật nhóm ngành thành công!'
                    })
                    Bus.$emit('update-school-level')
                } else {
                    this.$swal({
                        title: 'Lỗi !',
                        text: _.get(res, 'message', '')
                    })
                }
            }
        }
    }
}
</script>

<style scoped>

</style>